/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import Axios from "axios";
import store from "../store/store";
import constants from "./constants";
import AuthService from "../auth/authService";
import { getAppDomain } from "./getAppDomain";

// Global helper for HTTP requests
const LogoutHelper = async () => {
  const state = store.getState();
  let searchOptions = window.location.search;
  const authData = state.auth.tenantInfo;
  var authority = "";
  if (authData.tenantId) {
    var url = authData.logoutUrl;
    authority = url.replace("${}", authData.realm);
  }
  var tokenInfo = JSON.parse(localStorage.getItem("tokenInfo"));
  var absoluteDomain = getAppDomain() || "";
  const clearBrowserStorage = (logoutRedirect) => {
    var Cookies = document.cookie.split(";");
    for (var i = 0; i < Cookies.length; i++) {
      if (
        window.location.protocol === "https:" ||
        window.location.protocol === "HTTPS:"
      ) {
        document.cookie =
          Cookies[i].split("=")[0] +
          "=; path=/; domain=" +
          absoluteDomain +
          "; secure; expires=" +
          new Date(0).toUTCString();
      } else {
        document.cookie =
          Cookies[i].split("=")[0] +
          "=; path=/; domain=" +
          absoluteDomain +
          "; expires=" +
          new Date(0).toUTCString();
      }
    }
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem(
      "redirectUrl",
      window.location.pathname + (searchOptions ? searchOptions : ""),
    );
    store.dispatch({
      type: "LOGOUT",
      meta: { sync: true } // ensures redux-state-sync sends to other tabs
    });
    localStorage.removeItem("reduxState");
    localStorage.setItem("LOGOUT_EVENT", Date.now());
    if (logoutRedirect) {
      window.location.href = logoutRedirect;
    } else {
      // window.location.reload();
      window.location.href = '/';
    }
    window.location.href = '/'
  };
  if (tokenInfo && tokenInfo.id_token) {
    var logoutRedirect = null;
    if (
      state.auth.tenantInfo &&
      state.auth.tenantInfo.tenantProviderType === "SOLUTION_PROVIDER"
    ) {
      logoutRedirect = `${window.location.origin}/partner/${state.auth.tenantInfo.clientId}`;
    }
    var payload = {
      client_id: state.auth.tenantInfo.clientId,
      refresh_token: tokenInfo.refresh_token,
      id_token_hint: tokenInfo.id_token,
      // post_logout_redirect_uri: `${window.location.origin}/partner/geolocstar`,
      post_logout_redirect_uri:
        logoutRedirect || `${window.location.origin}/callback`,
    };
    let payloadNew = new URLSearchParams(Object.entries(payload)).toString();
    let headers = {};
    headers["Content-Type"] = "application/x-www-form-urlencoded";
    headers["Authorization"] = "Bearer " + state.auth.access_token;
    Axios.post(`${authData.baseUrl + authority}`, payloadNew, { headers })
      .then((res) => {
        console.log('logout done ====', res)
        clearBrowserStorage(logoutRedirect);
      })
      .catch((err) => {
        console.log('logout error', err)
        clearBrowserStorage(logoutRedirect);
      });
  } else {
    clearBrowserStorage();
  }
};

export default LogoutHelper;
